// PWA install prompt helpers
// Extracted from src/index.js into its own module to avoid webpack
// tree-shaking issues when other components import from index.js.

let deferredPrompt = null;

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new CustomEvent('pwaInstallAvailable'));
  });
}

export function getPWAInstallPrompt() {
  return deferredPrompt;
}

export function clearPWAInstallPrompt() {
  deferredPrompt = null;
}
